import React, { Component } from 'react';
import { Field, reduxForm } from 'redux-form';
import { required, mobile, confirmPhoneNumber } from '../../util/validations';
import { Input } from '../../util/controls';

class ContactDetailsEdit extends Component {
    constructor(props, context) {
        super(props, context);
    }



    render() {
        const { handleSubmit, pristine, submitting, formValues } = this.props;

       
        // Ensure we remove spaces from our input
        const phoneNumberOriginal = ((this.props.initialValues || {}).phoneNumber || "").replace(/\s/g, '');
        const phoneNumber = (formValues("phoneNumber") || "").replace(/\s/g, '');
        const phoneNumberConfirm = (formValues("phoneNumberConfirm") || "").replace(/\s/g, '');

        const phoneNumberIsValid = (phoneNumberOriginal === phoneNumber) || (phoneNumber === phoneNumberConfirm);

        return (
            <div>
                <h3>Update Contact Details</h3>
                <form onSubmit={handleSubmit}>
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card">
                                <div className="form-group">
                                    <label className="control-label" htmlFor="name">Contact</label>
                                    <Field name="contact" component={Input} type="text" className="form-control"
                                        validate={[required]} />
                                </div>

                                <div className="form-group">
                                    <label className="control-label" htmlFor="name">Mobile Number</label>
                                    <Field name="phoneNumber" placeholder="0412345678" component={Input} type="tel" className="form-control"
                                        validate={[required, mobile]} />

                                </div>
                                {
                                    phoneNumberOriginal !== phoneNumber ? (
                                        <div>
                                            <div className="form-group">
                                                <label className="control-label" htmlFor="name">Confirm Mobile Number</label>
                                                <Field name="phoneNumberConfirm" component={Input} type="tel" className="form-control"
                                                    validate={[required, mobile, confirmPhoneNumber]} />
                                            </div>
                                        </div>
                                    ) : null
                                }
                            </div>
                        </div>
                    </div>
                    <button type="submit" disabled={pristine || submitting || !phoneNumberIsValid} className="btn btn-client btn-lg btn-block">Submit</button>
                    <button type="button" className="btn btn-client-alt btn-lg btn-block" onClick={this.props.onCancel}>Cancel</button>
                </form>
            </div>
        );
    }
}

let contactDetailsEdit = reduxForm({
    form: 'contactdetails'
})(ContactDetailsEdit);

export default contactDetailsEdit;


// WEBPACK FOOTER //
// ./app/address/components/contactEdit.js